import { COLOR_OPTIONS } from 'config/style';
import STTypo from 'core/shared/typo';
import { useTranslation } from 'react-i18next';
import SvgInfo from 'st-protector-icons/Minor/Info';
import { StyledSelectionActionEmptyInfo } from './selection-empty-info.styles';

interface SelectionEmptyInfoProps {
  title?: string;
}

export const SelectionEmptyInfo = ({ title }: SelectionEmptyInfoProps): JSX.Element => {
  const [t] = useTranslation();

  return (
    <StyledSelectionActionEmptyInfo>
      <SvgInfo width={15} height={15} fill={COLOR_OPTIONS.BLUE_50} />
      <STTypo fontFamily='Noto Sans' fontWeight={400} color={COLOR_OPTIONS.WHITE}>
        {title ?? t('components.selection_action_button.items_empty_selection')}
      </STTypo>
    </StyledSelectionActionEmptyInfo>
  );
};
